import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";

export const FilterConditionsAccordionSkeleton = () => {
  return (
    <div className="flex flex-col gap-y-3 rounded-lg bg-white p-3 shadow-sm">
      <div className="flex items-center gap-x-2">
        <p className="basis-[72px] font-inter-medium-12px text-gray-700">
          Where
        </p>
        <div className="h-[34px] flex-1">
          <SkeletonPlaceholder height="h-full" rounded="rounded-lg" />
        </div>
        <div className="h-[34px] flex-1">
          <SkeletonPlaceholder height="h-full" rounded="rounded-lg" />
        </div>
      </div>
      <div>
        <Button iconLeft={faPlus} size="sm" variant="secondary" disabled>
          Add condition
        </Button>
      </div>
    </div>
  );
};
